import React from "react";
import { Box, Tooltip } from "@mui/material";

import { formatBirthDayDate } from "./UtilityFunctions";
import { Carousels, BirthDayShowCard, DOBTypography } from "../../Styles/AdminDashboard/CommonDashBoardStyle";

export const BirthDayShow = ({ upComingBirthDay, joiningAnniversaries  }) => {

  const combinedList = [
    ...upComingBirthDay.map(item => ({ ...item, type: "birthday" })),
    ...joiningAnniversaries.map(item => ({ ...item, type: "anniversary" }))
  ];

  return (
    <>
      {combinedList.length > 0 ? (
        <Carousels
          autoPlay={true}
          stopAutoPlayOnHover={true}
          indicators={false}
          swipe={true}
          animation={"fade"}
          interval={5000}
          duration={1500}
          navButtonsAlwaysInvisible={true}
        >
          {combinedList.map((item) => (
          <Tooltip title={item.type === "birthday" ? "Birthday 🎂" : "Work Anniversary 🎉"}>
            <BirthDayShowCard key={item._id || `${item.FirstName}-${item.Date_Of_Birth}`}>
              {/* <Box>
                <lord-icon
                  src={item.type === "birthday" ? "https://cdn.lordicon.com/fkmafinl.json" : "https://cdn.lordicon.com/npqajzml.json"}
                  trigger="loop"
                  delay="50"
                  style={{ width: "50px", height: "50px" }}
                />
              </Box> */}
                <Box>
                  <lord-icon
                    src={item.type === "birthday"
                      ? "https://cdn.lordicon.com/fkmafinl.json"
                      : "https://cdn.lordicon.com/npqajzml.json"
                    }
                    trigger="loop"
                    delay="50"
                    style={{ width: "50px", height: "50px" }}
                  />
                </Box>
                <Box>
                  <DOBTypography>
                    {item.FirstName} -{" "}
                    {formatBirthDayDate(item.type === "birthday" ? item.Date_Of_Birth : item.Date_Of_Join)}
                  </DOBTypography>
                </Box>
                {((item.type === "birthday" && new Date(item.Date_Of_Birth).getUTCMonth() === new Date().getUTCMonth() &&
                  new Date(item.Date_Of_Birth).getUTCDate() === new Date().getUTCDate()) ||
                  (item.type === "anniversary" && new Date(item.Date_Of_Join).getUTCMonth() === new Date().getUTCMonth() &&
                  new Date(item.Date_Of_Join).getUTCDate() === new Date().getUTCDate())) && (
                    <Box>
                      <lord-icon
                        src="https://cdn.lordicon.com/dkanzxbo.json"
                        trigger="loop"
                        colors="primary:#ee6d66,secondary:#e83a30,tertiary:#ffc738,quaternary:#9cf4df,quinary:#d4f49c"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </Box>
                )}
            </BirthDayShowCard>
          </Tooltip>
          ))}
        </Carousels>
      ) : (
        <Box sx={{ textAlign: "center", padding: "1rem" }}>
          <DOBTypography>No upcoming birthdays or anniversaries 🎉</DOBTypography>
        </Box>
      )}
    </>
  );
};
